import React from 'react';

import ActionButton from '../ActionButton';
import useAsyncAction from '../../hooks/useAsyncAction';
import './styles.scss';

type Props = {
	cps?: string;
	linked?: boolean;
	onGetAccountRecovery?: () => void | Promise<void>;
};

const ALLOWED_CP_ACCOUNT_RECOVERY_FLOW = ['netflix'];

const AccountRecovery: React.FC<Props> = ({ cps, linked, onGetAccountRecovery }) => {
	const { isLoading, errorMessage, run } = useAsyncAction(
		onGetAccountRecovery,
		'Error al recuperar la cuenta. Por favor, intenta nuevamente.'
	);

	if (!ALLOWED_CP_ACCOUNT_RECOVERY_FLOW.includes(cps!) || !linked) return null;

	return (
		<div className="account-recovery">
			<ActionButton
				label="Recuperar cuenta"
				onClick={run}
				isLoading={isLoading}
				disabled={!onGetAccountRecovery}
			/>
			{errorMessage && (
				<p className="error-message">{errorMessage}</p>
			)}
		</div>
	);
};

export default AccountRecovery;
